import React from 'react';
import '../styles/Footer.css';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

export default function Footer() {
    const year = new Date().getFullYear();
    
    return (
        <footer className="footer">
            <div className="footer-main">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <h3>WASA</h3>
                        <p className="footer-tagline">Work And Study Abroad</p>
                        <p className="footer-desc">Your trusted partner for international opportunities. We connect talent with global careers and education.</p>
                        <div className="footer-social">
                            <a href="#" className="social-link"><FaFacebookF /></a>
                            <a href="#" className="social-link"><FaInstagram /></a>
                            <a href="#" className="social-link"><FaLinkedinIn /></a>
                        </div>
                    </div>
                    
                    <div className="footer-links">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="#about">About Us</a></li>
                            <li><a href="#services">Services</a></li>
                            <li><a href="#contact">Contact</a></li>
                            <li><a href="#">Apply Now</a></li>
                        </ul>
                    </div>
                    
                    <div className="footer-services">
                        <h4>Our Services</h4>
                        <ul>
                            <li><a href="#">Visa Advisory</a></li>
                            <li><a href="#">Job Placement</a></li>
                            <li><a href="#">Student Recruitment</a></li>
                            <li><a href="#">Educational Loans</a></li>
                        </ul>
                    </div>
                    
                    <div className="footer-contact">
                        <h4>Contact Us</h4>
                        <ul className="contact-list">
                            <li>
                                <FaMapMarkerAlt className="contact-icon" />
                                <span>Lilongwe, Malawi</span>
                            </li>
                            <li>
                                <FaEnvelope className="contact-icon" />
                                <span>info@wasamw.com</span>
                            </li>
                            <li>
                                <FaPhone className="contact-icon" />
                                <a href="https://wa.me/265998993336" target='_blank' rel='noreferrer' style={{ color: '#d4af37', textDecoration: 'none' }}>+265 998 993 336</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div className="footer-bottom">
                <p>&copy; {year} Work And Study Abroad. All Rights Reserved.</p>
                <div className="footer-legal">
                    <a href="#">Privacy Policy</a>
                    <a href="#">Terms of Service</a>
                </div>
            </div>
        </footer>
    );
}